
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/api/charts/charts-data-provider-pro",
      function () {
        return require("private-next-pages/x/api/charts/charts-data-provider-pro.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/api/charts/charts-data-provider-pro"])
      });
    }
  